import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { ProjectSaleInfo } from '../model/projectsale.model';
import { EmpInfo } from '../model/emp.model';
import { SaleOrganizationInfo } from '../model/SaleOrganization.model';
import { ProjectInfo } from '../model/project.model';
import { RoleInfo } from '../model/role.model';
import { GlobalService } from '../service/global.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  FormArray
} from '@angular/forms';

import {
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { LookupInfo } from '../model/lookup.model';
import { CompanyInfo } from '../model/company.model';
import { async } from '@angular/core/testing';
import { strict } from 'assert';
import { data } from 'jquery';
import { SaletrackingInfo } from '../model/saletracking.model';
import { ProjectGroupInfo } from '../model/ProjectGroupInfo';
import { ProjectAssignManagerInfo } from '../model/projectassignmanager.model';
import { TokenService } from '../service/token.service';

@Component({
  selector: 'app-project-assign-manager',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './project-assign-manager.component.html',
  styleUrls: ['./project-assign-manager.component.css']
})
export class ProjectAssignManagerComponent implements OnInit {

  form: FormGroup;
  public body: string;
  ProjectAssignListPromise: Promise<ProjectAssignManagerInfo[]>
  ProjectAssignList: ProjectAssignManagerInfo[] = []
  ProjectAssignListPromisereturn: Promise<ProjectAssignManagerInfo[]>[]
  CategoryList: LookupInfo[]
  StatusList: LookupInfo[]
  ProjectSaleTypeList: LookupInfo[]
  ProjectSalePhaseList: LookupInfo[]
  ProjectSaleCustomerTypeList: LookupInfo[]
  EmployeeList: EmpInfo[]
  empList: EmpInfo[]
  empListLoad: EmpInfo[]
  empListPromise: Promise<EmpInfo[]>
  empListPromiseReturn: Promise<EmpInfo[]>
  saleOrganizationList: SaleOrganizationInfo[]
  saleOrganizationPromise: Promise<SaleOrganizationInfo[]>
  saleOrganizationMaxList: SaleOrganizationInfo[]
  RoleList: RoleInfo[]
  ProjectList: ProjectInfo[]

  // array control
  itemsSupport: FormArray;

  flagduplicate: boolean;
  hidProjectAssignManagerID: number

  // Zone pagination variable
  public indexNo: number = 0
  public currentPageNumber: number
  public totalPages: number
  public environment: number

  public empcodeinit: string
  _EmpCode: string;
  //_EmpName: string;
  hidebutton: Boolean;
  assignflag: boolean;
  viewflag: boolean;
  saleorglevelmax: number;
  saleorglevelemplogin: number;

  public currentPageNumberEmp: number
  public totalPagesEmp: number
  ProjectTotal: any
  EmpTotal: any
  isOnUpdate: boolean;
  isSubmitted: any;

  public totalActive: number
  public totalInActive: number
  public totalHold: number
  public totalClosed: number

  element: HTMLElement;
  public hidcouchk: number;
  public countall: number;

  baseurl: string;

  getreturn: Promise<string>;
  monthNameslist: any;
  yearlist: any[];

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
    GlobalService.CheckPagingAccessRights();
  }

  ngOnInit() {

    this.currentPageNumber = 1;
    // set PageSize
    this.environment = environment.PageSize;
    this.empcodeinit = localStorage.getItem("EmpCode");
    this._EmpCode = localStorage.getItem("EmpCode");
    //this._EmpName = localStorage.getItem("EmpName_TH");
    this.currentPageNumberEmp = 1;
    this.form = this.formBuilder.group({
      RoleNameSearch: [null],
      RoleCodeSearch: [null],
      StatusSearch: [null],
      ProjectCodeSearch: [null],
      RoleCode: [null],
      RoleName: [null],
      ProjectCode: [null],
      Status: [null],
      CreateBy: localStorage.getItem("EmpName_TH"),
      arraySupportTeam: this.formBuilder.array([this.createItemSupportTeamName()]),
      EmpCodeSearch: [null],
      EmpNameSearch: [null]
    });

    this.Clearinput();
    this.loadLookup('MASTERSTATUS').then((data) => {
      this.StatusList = data;
    });
    console.log(this.StatusList);
    this.LoadSaleOrganizationLevel();
    this.LoadListProjectGroup();
    this.LoadCountProjectGroup();
  }

  btnClick_SearchProjectAssignList() {
    this.currentPageNumber = 1; // away current page 1 when search
    this.indexNo = 0;
    this.LoadProjectSale()
  }
  Clearinput() {
    var d = new Date();
    var monthindex = d.getMonth() + 1;
    var year = d.getFullYear();

    this.form.patchValue({
      RoleCode: null,
      RoleName: null,
      RoleStatus: "1",
      CreateBy: localStorage.getItem("EmpCode") + " - " + localStorage.getItem("EmpName_TH"),

    });
  }

  createItemSupportTeamName(value = ''): FormGroup {
    return this.formBuilder.group({
      SupporTeamName: [value],
    },
      {
        // Used custom form validator 
        validator: []
      }
    );

  }

  ClearSearch() {
    this.form.patchValue({
      RoleNameSearch: "",
      ProjectSaleCompanyIdSearch: "",
      RoleStatusSearch: "",
    });
    this.currentPageNumber = 1;
    this.indexNo = 0;
    this.LoadProjectSale();
  }

  LoadProjectSale(traget = null) {

    // check call function from change page or onloadfrist
    if (traget != null) {
      this.LoadProjectSaleUpdatePagination(traget);
    }

    //this.LoadProjectAssignList();
    this.LoadProjectSaleCountList();
  }

  async LoadProjectAssignList() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * this.environment;

      var objectjson = {};
      objectjson['RoleCode'] = this.checkUndefinedString(this.form.controls['RoleCodeSearch'].value);
      //objectjson['ProjectCode'] = this.checkUndefinedString(this.form.controls['ProjectCodeSearch'].value);
      objectjson['FlagActive'] = this.checkUndefinedString(this.form.controls['StatusSearch'].value) != "" ? this.checkUndefinedString(this.form.controls['StatusSearch'].value) : null;
      objectjson['rowFetch'] = this.environment;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<ProjectAssignManagerInfo[]>(this.baseurl + "ProjectAssignManager/GetProjectAssign", strjson, httpOptions)
        .toPromise().then((data) => {
          
          this.ProjectAssignList = data

        })
    }

  }

  async LoadProjectSaleCountList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['RoleName'] = this.checkUndefinedString(this.form.controls['RoleNameSearch'].value);
      objectjson['CreateBy'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value);

      if (this.viewflag == true) {
      }
      else {
        objectjson['CreateBy'] = this.checkUndefinedString(this.empcodeinit);
      }
      objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<RoleInfo[]>(this.baseurl + "Role/GetRole", strjson, httpOptions)
        .toPromise().then((data) => {
          this.hidcouchk = data.length;
          if (this.hidcouchk == 0) {
            this.currentPageNumber = 0;
            this.totalPages = 0;
          } else {
            this.totalPages = Math.ceil(this.hidcouchk / this.environment);
          }

        })
    }
  }

  async LoadRoleList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<RoleInfo[]>(this.baseurl + "Role/GetRole", strjson, httpOptions)
        .toPromise().then((data) => {

          this.RoleList = data

        })
    }
  }

  async LoadProjectList() {

    var pathapi = "Project/GetProjectCriteria";
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let data = {};
      
      data["FlagDelete"] = "N";

      let strjson = JSON.stringify(data);

      this.httpClient.post<ProjectInfo[]>(this.baseurl + "Project/GetProjectCriteria", strjson, httpOptions)
        .toPromise().then((data) => {

          this.ProjectList = data

        })
    }
  }

  async btnClick_submitInsertProjectAssign() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      /*console.log(this.form);*/
      if (this.form.valid) {
        console.log('form submitted');
        this.OnCreating('y');

        // gen array support control to json
        this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
        var jsonsupportteam = this.ConvertFormArrayToJson(this.itemsSupport);
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['RoleCode'] = this.checkUndefinedString(this.form.controls['RoleCode'].value);
        objectjson['ProjectCode'] = this.checkUndefinedString(this.form.controls['ProjectCode'].value);
        objectjson['FlagActive'] = this.checkUndefinedString(this.form.controls['Status'].value);
        objectjson['CreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
        objectjson['FlagDelete'] = "N";

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<ProjectAssignManagerInfo[]>(this.baseurl + "ProjectAssignManager/InsertProjectAssign", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Insert fail")
            this.OnCreating('n');
          },
            () => {
              console.log("Insert = " + this.isSubmitted)
              this.OnCreating('n');
              $('#ModalCreateComplate').modal();
              this.currentPageNumber = 1;
              this.indexNo = 0;
              this.LoadProjectAssignList();
            }
          )

      } else {
        this.GlobalService.validateAllFormFields(this.form);
      }
    }
  }

  btnClick_onUpdateProjectAssign(id) {
    $('#ModalProjectSale').modal('hide');
    //this.Clearinput();
    this.isOnUpdate = true

    let index = this.ProjectAssignList.findIndex(x => x.ProjectAssignManagerID == id);


    var d = new Date();
    var monthindex = d.getMonth() + 1;
    var yearcurrent = d.getFullYear();
    this.form.patchValue({
      RoleCode: this.ProjectAssignList[index].RoleCode != null ? this.ProjectAssignList[index].RoleCode : null,
      ProjectCode: this.ProjectAssignList[index].ProjectCode != null ? this.ProjectAssignList[index].ProjectCode : null,
      Status: this.ProjectAssignList[index].StatusName != null ? this.ProjectAssignList[index].StatusName : null,

    });
    this.hidProjectAssignManagerID = this.ProjectAssignList[index].ProjectAssignManagerID
    $('#ModalProjectAssign').modal();
  }

  async btnClick_submitUpdateProjectAssign(id) {
    if (this.form.valid) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.OnUpdating('y');
        id = this.hidProjectAssignManagerID
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['ProjectAssignManagerID'] = id;
        objectjson['RoleCode'] = this.checkUndefinedString(this.form.controls['RoleCode'].value);
        objectjson['ProjectCode'] = this.checkUndefinedString(this.form.controls['ProjectCode'].value);
        objectjson['FlagActive'] = this.checkUndefinedString(this.form.controls['Status'].value);
        objectjson['UpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<ProjectAssignManagerInfo[]>(this.baseurl + "ProjectAssignManager/UpdateProjectAssign", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail");
            this.OnUpdating('n');
          },
            () => {
              console.log("Update = " + this.isSubmitted);
              this.OnUpdating('n');
              $('#ModalUpdateComplate').modal();

              this.LoadProjectSale();

            }
          )
      }
    } else {
      this.GlobalService.validateAllFormFields(this.form);
    }
  }

  btnClick_deleteProjectAssign(auth_token, id): Observable<ProjectAssignManagerInfo[]> {
  
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['RoleId'] = id;

      let strjsonCusInfo = JSON.stringify(objectjson);

    return this.httpClient.post<ProjectAssignManagerInfo[]>(this.baseurl + "ProjectAssignManager/DeleteProjectAssign", strjsonCusInfo, httpOptions);
    
  }

  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");

    $('[name="checkboxProjectSale"]').prop('checked', check);

  }

  async btnClick_deleteProjectSaleitem(id) {

    if (confirm("Are you sure you want to delete this Project ?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.btnClick_deleteProjectAssign(auth_token,parseInt(id)).toPromise()
          .then(
            data => {
              console.log('หลังรับค่า');
              $('#ModalDeleteComplate').modal('show');
              this.LoadProjectAssignList();
            }
          );
      }
    }

  }

  //Delete แบบ list
  async btnClick_onDeleteProjectAssignList() {

    if (confirm("Are you sure you want to delete this Project?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        var checkkedProjectSale = $('[name="checkboxProjectSale"]:checked');

        let num = checkkedProjectSale.length;
        let observableBatch = [];
        for (var i = 0; i < num; i++) {

          var ProjectSalecurrent = <HTMLInputElement>checkkedProjectSale[i];
          observableBatch.push(this.btnClick_deleteProjectAssign(auth_token,parseInt(ProjectSalecurrent.value)).toPromise().then(val => {
          }));
        }

        Promise.all(observableBatch).then(val => {

          this.SendListIdToDelete(observableBatch);

        });
      }
    }
  }
  async SendListIdToDelete(observableBatch: any[]) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjsonCusInfo = JSON.stringify(observableBatch);

      return this.httpClient.post<ProjectGroupInfo[]>(this.baseurl + "Master/DeleteListProjectGroup", strjsonCusInfo, httpOptions)
        .toPromise()
        .then(
          data => {
            console.log('สำเร็จ');
            $('#ModalDeleteComplate').modal('show');
            this.currentPageNumber = 1;
            this.LoadProjectSale();
          }
        );
    }
  }

  btnClick_onCreateProjectAssign() {
    this.form.reset();
    $('#ModalProjectAssign').modal('show');
    this.Clearinput();
    this.isOnUpdate = false
    this.LoadRoleList();
    this.LoadProjectList();

  }

  isFieldValid(field: string) {
    return !this.form.get(field).valid && this.form.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  async loadLookup(lookuptype: string) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LookupType'] = this.checkUndefinedString(lookuptype);

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise()
    }
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  OnCreating(flag) {
    if (flag == 'y') {
      $("#loadingcreate").show();
      $("#btnsubmitProjectAssign").hide();
      $("#txtProjectSaleCode").prop('disabled', true);
      $("#txtProjectSaleName").prop('disabled', true);
      $("#txtProjectSaleContactName").prop('disabled', true);
      $("#txtProjectSaleLink").prop('disabled', true);
      $("#txtProjectSaleIndustry").prop('disabled', true);
      $("#txtProjectSaleCustomerType").prop('disabled', true);
      $("#txtProjectSaleDescription").prop('disabled', true);
      $('#btncloseicon').prop('disabled', true);
      $('#btnclose').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingcreate").hide();
      $("#btnsubmitProjectAssign").show();
      $("#txtProjectSaleCode").removeAttr('disabled');
      $("#txtProjectSaleName").removeAttr('disabled');
      $("#txtProjectSaleContactName").removeAttr('disabled');
      $("#txtProjectSaleLink").removeAttr('disabled');
      $("#txtProjectSaleIndustry").removeAttr('disabled');
      $("#txtProjectSaleCustomerType").removeAttr('disabled');
      $("#txtProjectSaleDescription").removeAttr('disabled');
      $('#btncloseicon').removeAttr('disabled');
      $('#btnclose').removeAttr('disabled');
      $('#ModalProjectSale').modal('hide');
    }
  }

  OnUpdating(flag) {
    if (flag == 'y') {
      $("#loadingupdate").show();
      $("#btnsubmitProjectAssign").hide();
      $("#txtProjectSaleCode").prop('disabled', true);
      $("#txtProjectSaleName").prop('disabled', true);
      $("#txtProjectSaleContactName").prop('disabled', true);
      $("#txtProjectSaleLink").prop('disabled', true);
      $("#txtProjectSaleIndustry").prop('disabled', true);
      $("#txtProjectSaleCustomerType").prop('disabled', true);
      $("#txtProjectSaleDescription").prop('disabled', true);
      $('#btncloseicon').prop('disabled', true);
      $('#btnclose').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingupdate").hide();
      $("#btnsubmitProjectAssign").show();
      $("#txtProjectSaleCode").removeAttr('disabled');
      $("#txtProjectSaleName").removeAttr('disabled');
      $("#txtProjectSaleContactName").removeAttr('disabled');
      $("#txtProjectSaleLink").removeAttr('disabled');
      $("#txtProjectSaleIndustry").removeAttr('disabled');
      $("#txtProjectSaleCustomerType").removeAttr('disabled');
      $("#txtProjectSaleDescription").removeAttr('disabled');
      $('#btncloseicon').removeAttr('disabled');
      $('#btnclose').removeAttr('disabled');
      $('#ModalProjectSale').modal('hide');
    }
  }

  displayhyperlink(projectcode: string, projectsaleid: number) {
    var body = ""
    body += " <a href=\"/saletracking-management?ProjectSaleID=" + projectsaleid + "\">" + projectcode + "</a>"

    return body;
  }

  LoadSaleOrganizationLevel() {

    this.LoadSaleOrganizationLevelList().then(data => {
      this.saleOrganizationList = data;

      //console.log("SaleOrganization List : " + JSON.stringify(this.saleOrganizationList));

      if (this.saleOrganizationList.length > 0) {
        if (this.saleOrganizationList[0].AssignFlag == 'Y') {
          this.hidebutton = false;
          this.assignflag = false;
        }
        else {
          this.hidebutton = true;
          this.assignflag = true;
        }
      }
      else {
        this.hidebutton = true;
        this.assignflag = true;
      }

      if (this.saleOrganizationList.length > 0) {
        if (this.saleOrganizationList[0].ViewFlag == 'Y') {
          this.viewflag = true;
        }
        else {
          this.viewflag = false;
        }
      }
      else {
        this.viewflag = false;
      }

      if (this.saleOrganizationList.length > 0) {
        this.saleorglevelemplogin = this.saleOrganizationList[0].Levels
      }
      else {
        this.saleorglevelemplogin = 1;
      }

      this.LoadProjectSale();
    }).then(() => {
      this.LoadSaleOrganizationLevelmax();

    });
  }

  async LoadSaleOrganizationLevelList(): Promise<SaleOrganizationInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumberEmp - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['EmpCode'] = this.checkUndefinedString(this.empcodeinit);

      let strjson = JSON.stringify(objectjson);

      this.saleOrganizationPromise = this.httpClient.post<SaleOrganizationInfo[]>(this.baseurl + "SaleOrganization/GetSaleOrganization", strjson, httpOptions)
        .toPromise()

      return this.saleOrganizationPromise;
    }
  }

  async LoadSaleOrganizationLevelmax() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumberEmp - 1) * environment.PageSize;

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<SaleOrganizationInfo[]>(this.baseurl + "SaleOrganization/GetSaleOrganization", strjson, httpOptions)
        .toPromise().then(
          data => {
            this.saleOrganizationMaxList = data;
            this.saleOrganizationMaxList = this.saleOrganizationMaxList.sort((a, b) => a.Levels - b.Levels);

            if (this.saleOrganizationMaxList.length > 0) {
              this.saleorglevelmax = this.saleOrganizationMaxList[this.saleOrganizationMaxList.length - 1].Levels;

            }
            else {
              this.saleorglevelmax = 1;
            }
          })
    }
  }


  ConvertFormArrayToJson(objectFormArray: FormArray): string {
    var objectarray = [];
    $.each(objectFormArray.controls, function (index, value) {
      objectarray.push(value.value);
    });

    return JSON.stringify(objectarray);

  }

  // Function Update variable abount pagination
  LoadProjectSaleUpdatePagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
    this.indexNo = traget.index;

  }

  //Lead group
  //function Update Group projectsale
  //1. Get list project group to modal
  //2. Send list projs id to save 
  //Variables
  listProjGroup: RoleInfo[] = [];
  totalProjectGroup: number;
  totalPage_ProjectGroup: number;
  currentPageNumber_ProjectGroup: number;

  async LoadListProjectGroup() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<RoleInfo[]>(this.baseurl + "Role/GetRole",
          strjson, httpOptions)
        .subscribe(data => {
          this.listProjGroup = data;
        });
    }
  }

  async LoadCountProjectGroup() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<number>(this.baseurl + "Master/GetCountProjectGroup",
          strjson, httpOptions)
        .subscribe(data => {

          this.currentPageNumber_ProjectGroup = 1;
          this.totalProjectGroup = data;//จำนวน data ทั้งหมด

          if(this.totalProjectGroup == 0){
            this.currentPageNumber_ProjectGroup = 0;
          }

          this.totalPage_ProjectGroup = Math.ceil(this.totalProjectGroup / environment.PageSize);//จำนวนที่แบ่ง page ได้
        });
    }
  }

  OnLoadProjGroupFinished(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber_ProjectGroup = traget.currentPageNumber;
      this.totalPage_ProjectGroup = traget.totalPages;
    }

    this.LoadListProjectGroup();
  }
  OnBtnOpenProjectGroupModalClick() {
    $('#ModalProjectGroup').modal();
  }
}
